import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const reviews = [
  {
    "name": "Emily R.",
    "location": "New York, USA",
    "review": "I found the cheapest flight booking in New York through this service! The support team was super helpful, and I got a great deal within minutes. Highly recommended!",
    "rating": 5
  },
  {
    "name": "Michael T.",
    "location": "California, USA",
    "review": "Booking my flight from Los Angeles was seamless! They provided affordable flight tickets in California with zero hassle. Excellent service and 24/7 support!",
    "rating": 5
  },
  {
    "name": "Sophia L.",
    "location": "Florida, USA",
    "review": "I needed a last-minute flight, and they offered me cheap airfare deals in Florida instantly. Great prices and fast service – will book again!",
    "rating": 5
  },
  {
    "name": "David W.",
    "location": "Texas, USA",
    "review": "Hands down the best platform for low-cost flight tickets in Texas! The travel coordinators were amazing, and I saved big on my booking.",
    "rating": 5
  },
  {
    "name": "Jessica M.",
    "location": "Illinois, USA",
    "review": "If you're looking for the best flight deals in Illinois, this is the place to go! Super easy booking process and great customer support.",
    "rating": 5
  },
  {
    "name": "Ryan K.",
    "location": "Nevada, USA",
    "review": "I booked my Vegas trip at the cheapest airfare in Nevada! Hassle-free and smooth process with amazing customer service.",
    "rating": 5
  },
  {
    "name": "Olivia D.",
    "location": "Washington, USA",
    "review": "Absolutely loved the service! I got a great discount on my flight booking in Washington. The best site for stress-free travel planning.",
    "rating": 5
  },
  {
    "name": "Daniel S.",
    "location": "Georgia, USA",
    "review": "They made finding the cheapest flights in Georgia so easy! Great experience and unbeatable prices.",
    "rating": 5
  },
  {
    "name": "Matthew B.",
    "location": "Arizona, USA",
    "review": "I was impressed by their dedication to finding low-fare flights in Arizona. Quick and reliable service!",
    "rating": 5
  },
  {
    "name": "Isabella C.",
    "location": "Pennsylvania, USA",
    "review": "Fast, reliable, and super affordable! I secured the best flight deals in Pennsylvania with ease. Highly recommended!",
    "rating": 5
  },
  {
    "name": "Ethan H.",
    "location": "North Carolina, USA",
    "review": "I was able to grab a cheap flight from North Carolina thanks to their expert assistance. The process was smooth and quick!",
    "rating": 5
  },
  {
    "name": "Ava J.",
    "location": "Ohio, USA",
    "review": "Highly satisfied with my experience! The cheapest airfare in Ohio was available here, and their team was super helpful.",
    "rating": 5
  },
  {
    "name": "Mason P.",
    "location": "Michigan, USA",
    "review": "I saved a lot booking my flight! They truly offer the lowest flight prices in Michigan, and the service is fantastic.",
    "rating": 5
  },
  {
    "name": "Charlotte N.",
    "location": "Colorado, USA",
    "review": "I was amazed by the fast response and incredible discounts. The best airfare deals in Colorado were right here!",
    "rating": 5
  },
  {
    "name": "Liam G.",
    "location": "Minnesota, USA",
    "review": "I found budget-friendly flights in Minnesota without any hassle! Super reliable and trustworthy service.",
    "rating": 5
  },
  {
    "name": "Amelia V.",
    "location": "Tennessee, USA",
    "review": "Got my flight tickets at the lowest airfare in Tennessee within minutes! Amazing platform for booking flights.",
    "rating": 5
  },
  {
    "name": "Noah D.",
    "location": "Oregon, USA",
    "review": "They helped me secure affordable flight tickets from Oregon hassle-free. Best travel service I’ve used!",
    "rating": 5
  },
  {
    "name": "Harper S.",
    "location": "New Jersey, USA",
    "review": "If you need the cheapest flight bookings in New Jersey, this is the place to go! Reliable, affordable, and quick.",
    "rating": 5
  },
  {
    "name": "Elijah K.",
    "location": "Massachusetts, USA",
    "review": "Booking a flight from Boston was easy! I found low-cost airfare in Massachusetts with zero complications.",
    "rating": 5
  },
  {
    "name": "Abigail F.",
    "location": "Indiana, USA",
    "review": "Excellent service with affordable flights in Indiana! The support team guided me perfectly.",
    "rating": 5
  }
]


const ClientReviews = () => {
  return (
    <div className="container my-5">
      <h2 className="text-center mb-4 fw-bold">⭐ Our Client Reviews ⭐</h2>
      <div id="reviewCarousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          {reviews.reduce((acc, review, index) => {
            if (index % 3 === 0) acc.push([]);
            acc[acc.length - 1].push(review);
            return acc;
          }, []).map((group, groupIndex) => (
            <div key={groupIndex} className={`carousel-item ${groupIndex === 0 ? "active" : ""}`}>
              <div className="row justify-content-center">
                {group.map((review, index) => (
                  <div key={index} className="col-md-4 d-flex">
                    <div className="card p-3 shadow-sm border rounded flex-fill d-flex flex-column">
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title fw-bold">{review.name}</h5>
                        <h6 className="text-muted">{review.location}</h6>
                        <p className="card-text flex-grow-1 mt-2">"{review.review}"</p>
                        <div className="text-warning fs-5">
                          {"⭐".repeat(review.rating)}
                          {"☆".repeat(5 - review.rating)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#reviewCarousel" data-bs-slide="prev">
          <span className="carousel-control-prev-icon" style={{ color: "#fff" }} aria-hidden="true"></span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#reviewCarousel" data-bs-slide="next">
          <span className="carousel-control-next-icon" style={{ color: "#fff" }} aria-hidden="true"></span>
        </button>
      </div>
    </div>
  );
};

export default ClientReviews;
